(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/side-nav/assets/javascripts/lazy-quick-bet.js') >= 0) return;  svs.modules.push('/components/tipsen/side-nav/assets/javascripts/lazy-quick-bet.js');
"use strict";

const tipsenLazy = svs.components.tipsen.tipsenLazy.tipsenLazy;
const LazyQuickBet = tipsenLazy('/cl/tipsen/route-play-quick-bet', () => svs.components.tipsen.routePlayQuickBet.RoutePlayQuickBet);
setGlobal('svs.components.tipsen.sideNav.LazyQuickBet', LazyQuickBet);

 })(window);